<div class="d-flex justify-content-end align-items-center">
  @for (action of actions; track action.kind) {
    @switch (action.kind) {
      @case ("delete") {
        @if (action.canDelete(item) == "yes") {
          <a
            (click)="showDeletePopUp(action)"
            style="width: 15px"
            class="text-sm ms-3"
            id="notDisabled"
            data-bs-toggle="tooltip"
            title="{{ itemLabel }} verwijderen"
          >
            <i class="fa-solid fa-trash" style="vertical-align: bottom"></i>
          </a>
        } @else if (action.canDelete(item) == "disabled") {
          <div
            style="width: 15px"
            class="text-sm ms-3"
            (click)="action.onDisabledClick ? action.onDisabledClick(item) : null"
          >
            <i
              class="fa-solid text-muted fa-trash"
              style="vertical-align: bottom"
              id="Disabled"
            ></i>
          </div>
        }
      }
      @case ("add") {
        @if (action.canAdd(item)) {
          <a (click)="openAddModal(action)">
            <i
              class="fa-solid fa-circle-plus text-lg text-success ms-3"
              style="vertical-align: middle"
              title="{{ itemLabel }} toevoegen"
              style="vertical-align: middle"
            ></i>
          </a>
        }
      }
      @case ("edit") {
        @if (action.canEdit(item) != "no") {
          <a (click)="openEditModal(action)">
            <i
              class="fa-solid fa-pencil ms-3"
              style="vertical-align: middle"
              title="{{ itemLabel }} bewerken"
            ></i>
          </a>
        }
      }

      @case ("move") {
        @if (action.canMove(item)) {
          @if (!isLast) {
            <a (click)="moveDown(action)">
              <i
                class="fa-solid fa-arrow-down ms-3"
                style="vertical-align: middle"
                title="Naar beneden verplaatsen"
              ></i>
            </a>
          } @else {
            <i
              class="fa-solid fa-arrow-down ms-3 text-muted"
              style="vertical-align: middle"
              title="Naar beneden verplaatsen"
            ></i>
          }
          @if (!isFirst) {
            <a (click)="moveUp(action)">
              <i
                class="fa-solid fa-arrow-up ms-3"
                style="vertical-align: middle"
                title="Naar boven verplaatsen"
              ></i>
            </a>
          } @else {
            <i
              class="fa-solid fa-arrow-up ms-3 text-muted"
              style="vertical-align: middle"
              title="Naar boven verplaatsen"
            ></i>
          }
        }
      }
    }
  }
</div>
